<template>
    <div>
        <component
            :is="component.type"
            v-model="component.value"
            :v="validation"
        />
    </div>
</template>

<script>
import sections from './sections';

export default {
    components: {
        ...sections
    },

    props: {
        value: {
            type: Object,
            required: false,
            default: () => ({})
        },
        editMode: {
            type: Boolean,
            required: false,
            default: false
        },
        validation: {
            type: Object,
            required: true
        },
        serverErrors: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            section: { value: 'newsbreaker' },
            component: {}
        };
    },

    watch: {
        component() {
            this.$emit('input', this.component);
        }
    },

    created() {
        this.component = { ...this.value };
    }
};
</script>
